import React, { useEffect, useState, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useUtilisateur from "../../hooks/useUtilisateur";
import { AuthContext } from "../../contexts/AuthContext";
import LoaderAuth from "../../components/loader/authentification/LoaderAuth";
const CallbackSocialConnection = () => {
  const [searchParams] = useSearchParams();
  const idUser = searchParams.get("userId") || "";
  const access = searchParams.get("access") || "";
  const refresh = searchParams.get("refresh") || "";
  const navigate = useNavigate();
  const { setIsLogged, setUser, setAccessToken, setRefreshToken, setIsAdmin } =
    useContext(AuthContext);
  const { getOneUser } = useUtilisateur();
  useEffect(() => {
    if (idUser && access && refresh) {
      const resterConnecter = sessionStorage.getItem("resteConnecter");
      setAccessToken(access);
      setRefreshToken(refresh);
      if (resterConnecter == "false") {
        sessionStorage.removeItem("resteConnecter");
        // Sauvegarde dans le localStorage
        sessionStorage.setItem("accessToken", access);
        sessionStorage.setItem("refreshToken", refresh);
        sessionStorage.setItem("isLogged", true);
      } else {
        // Sauvegarde dans le localStorage
        sessionStorage.removeItem("resteConnecter");
        localStorage.setItem("accessToken", access);
        localStorage.setItem("refreshToken", refresh);
        localStorage.setItem("isLogged", true);
      }

      getOneUser(idUser)
        .then((res) => {
          
          if (res.data.data) {
            const user = res.data.data;
            setUser(user);

            if (resterConnecter == "false") {
              sessionStorage.setItem("user", JSON.stringify(user));
            } else {
              // Sauvegarde dans le localStorage
              localStorage.setItem("user", JSON.stringify(user));
            }

            setIsLogged(true);
            if (res.data.role == 1) {
              setIsAdmin(true);
              navigate("/admin/dashboard");
            } else {
              setIsAdmin(false);
              const navigation = localStorage.getItem("navigation");
              if (navigation == "login") {
                localStorage.removeItem("navigation");
                navigate("/");
              } else {
                localStorage.removeItem("navigation");
                navigate("/article/creation");
              }
            }
          }
        })
        .catch((err) => {
          console.log("erreur", err);
          navigate("/login");
        });
    } else {
      navigate("/login");
    }
  }, []);
  return <LoaderAuth/>
};

export default CallbackSocialConnection;
